// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4363":"f537670f","5608":"ca53aa86","6832":"f537670f","8491":"2070c431","8976":"34f0f20a"}[chunkId] + ".chunk.css";
};